var layers = [
  {
    label: {
      de: 'Implantat',
      en: 'Implant'
    },
    required: false,
    range: 1,
    maxunits: 32,
    id: 'implant',
    applyTo: 'both',
    text: 'x',
    color: 'transparent',
    textColor: 'red',
  }
];

var LayerTree = require('./LayerTree.js');
let constructionLayers = {
  P: 'Primär',
  F: 'Festsitzend',
  H: 'Herausnehmbar'
};
Object.keys(constructionLayers).forEach((key) => {
  layers.push({
    label: constructionLayers[key],
    formLabel: constructionLayers[key],
    id: key,
    range: 16,
    minrange: key === 'H' ? 16 : undefined,
    maxunits: 32,
    withinJaw: true,
    applyTo: 'both',
    popup: [
      {
        label: constructionLayers[key],
        formLabel: {
          de: 'Produktdetails',
          en: 'Product details',
        },
        productTree: LayerTree(key),
      }
    ]
  });
});

module.exports = {
  type: 'selector',
  id: 'therapy',
  title: 'Therapie',
  icon: 'fad fa-teeth-open',
  teethView: 'top',
  layers: layers
}


/*

About layers:
* `maxunits`: The maximum number of units that can be placed in one jaw
* `range`: The maximum number of teeth that be selected
* `applyTo`: To what jaws should the layer apply?
  - `both`: Both jaws
  - `upper`: Only lower jaw
  - `upper`: Only upper jaw

If one of the jaws has no layers, it will not be displayed

*/
